import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const RecordingModalChannelInfo = styled.span<React.CSSProperties>`
  align-self: center;
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${40 * Screen.widthRatio}px;
  text-align: center;
`;

export default RecordingModalChannelInfo;
